import { ReactElement, ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { useControlStore } from '@editorStores'

interface Props {
  children: ReactNode
}

export const StoreyControlsPortal = ({ children }: Props): ReactElement => {
  const storeyControlsPortalElement = useControlStore(state => state.storeyControlsPortalElement)

  return (
    <>{storeyControlsPortalElement && createPortal(<>{children}</>, storeyControlsPortalElement)}</>
  )
}
